module.exports = __webpack_public_path__ + "img/@logo_gsk.90421620.png";